import {field} from "../../../stem-core/state/StoreField.js";
import {EmailSendingStoreObject, MerchantEmailCampaignStatus, MerchantEmailCampaign} from "./MerchantEmailCampaignStore";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {BaseStore, globalStore} from "../../../stem-core/state/Store.js";
import {Merchant} from "../MerchantStore";
import {StemDate} from "../../../stem-core/time/Date";
import {EmailTemplate} from "../EmailTemplateStore";

@globalStore
export class MerchantEmailCampaignSegment extends BaseStore("MerchantEmailCampaignSegment", {}, EmailSendingStoreObject) {
    @field("Merchant") merchant: Merchant;
    @field("MerchantEmailCampaign") campaign: MerchantEmailCampaign;
    @field(String) name: string;
    @field("EmailTemplate") template: EmailTemplate;
    @field(Date) createdAt: StemDate;
    @field(MerchantEmailCampaignStatus) status: MerchantEmailCampaignStatus;
    @field(Date) scheduledSendDate: StemDate;
    @field(Object) extraFilters: any; // MerchantAudienceFilters
    @field(Number) maxEmailsToSend: number;

    canBeEdited() {
        return this.status === MerchantEmailCampaignStatus.UNSCHEDULED ||
               this.status === MerchantEmailCampaignStatus.SCHEDULED ||
               this.status === MerchantEmailCampaignStatus.STOPPED;
    }
}

export async function apiMerchantCreateEmailCampaignSegment(request) {
    const response = await apiClient.post("/merchant/create_email_campaign_segment/", request);
    return MerchantEmailCampaignSegment.loadObject(response);
}

export async function apiMerchantEditEmailCampaignSegment(request) {
    return await apiClient.post("/merchant/edit_email_campaign_segment", request, {allowNulls: true});
}

export async function apiMerchantStopEmailCampaignSegment(request) {
    return await apiClient.post("/merchant/stop_email_campaign_segment", request);
}